<div class="flex flex-col gap-8 p-6 rounded-lg border border-purple-2">
  <div class="flex flex-col gap-1">
    <span class="title-1-semibold">
      You've been invited to partner with
      {{ partnership().counterpartyOrganizationName }}
    </span>
    <span class="body-1-regular text-grey-5"
      >To begin streamlining applications and accepting placements at your site,
      review and accept the Affiliation Agreement.
    </span>
  </div>
  <div class="flex flex-col gap-2">
    <app-affiliation-agreement-name-tile
      [name]="agreement().name"
      [source]="agreement().source"
      nameStyleClass="body-1-semibold"
    />

    <app-wrapped-chips-rows
      [items]="disciplines()"
      [maxRowCount]="2"
      [firstItemTemplate]="agreementDates"
      chipStyleClass="border-none"
    />
  </div>
  <p-button
    label="Review Agreement"
    styleClass="h-8"
    (onClick)="viewAgreement.emit()"
  />
</div>

<ng-template #agreementDates>
  <div class="flex items-center gap-1 px-2.5 py-0.5 rounded-3xl bg-black-1">
    <span
      class="material-symbols-rounded text-grey-6 leading-[1.125rem] text-lg"
      >calendar_today</span
    >
    <span class="body-1-regular"
      >{{ agreement().startDate | usDate }} -
      {{ (agreement().endDate | usDate) ?? "Indefinitely" }}</span
    >
  </div>
</ng-template>
